/* eslint-disable default-param-last */
import { Can, Obj, InterfaceReducer } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
import AbstractItemDelegate from "../../dataSource/AbstractItemDelegate.js";
import { ImagineHistoryComparatorConverterFactory, ImagineHistoryFilterConverterFactory, ImagineHistorySortConverterFactory } from "./Factory.js";
export default class HistoryItemDelegate extends AbstractItemDelegate {
  static TYPE = 'imagine.HistoryItemDelegate';
  constructor(options) {
    super(options);
    const {
      match,
      relationship
    } = options;
    this.match = match;
    this.relationship = relationship.isResolved ? relationship : relationship.createResolved(match);
    this.systemId = relationship.systemId;
    this.id = this.relationship.id;
    this.can = new Can(this.getInterfaceUrl(), false, false);
    this.type = HistoryItemDelegate.TYPE;
  }
  getInterfaceUrl() {
    return this.relationship.objRefUrl;
  }
  canConvertCondition(cnd, cxt) {
    return ImagineHistoryFilterConverterFactory.get(cnd) != null;
  }
  canConvertComparator(cmp, cxt) {
    return ImagineHistoryComparatorConverterFactory.get(cmp) != null;
  }
  convertToFilter(cnd, cxt) {
    return ImagineHistoryFilterConverterFactory.create(cnd, {
      ...cxt,
      filterConverterFactory: ImagineHistoryFilterConverterFactory,
      comparatorConverterFactory: ImagineHistoryComparatorConverterFactory
    });
  }
  convertToSort(attrSortModel, cxt) {
    return ImagineHistorySortConverterFactory.create(attrSortModel, {
      ...cxt,
      sortConverterFactory: ImagineHistorySortConverterFactory
    });
  }
  createObj() {
    const pUrl = this.relationship.ref;
    return Obj.create(pUrl, this.id, this.relationship.attributes != null);
  }
  search(query, options) {
    return this.createObj().history(query, options);
  }
  canList(state = GlobalState.get(), requestIfUnavailable = true) {
    const can = this.can.getHistory(state);
    if (can == null && requestIfUnavailable) {
      GlobalState.dispatch(this.requestCanList());
    }
    return can;
  }

  /**
   * Returns a redux action that will ask the api if you can get history at the current path
   * @param {object} query  query object to send to the api
   */
  requestCanList(query) {
    return this.can.history(query);
  }

  // eslint-disable-next-line default-param-last
  getList(state = GlobalState.get(), queryName, options) {
    return InterfaceReducer.getHistory(state, `${this.getInterfaceUrl()}.history`, queryName, options);
  }

  // eslint-disable-next-line default-param-last
  getError(state = GlobalState.get(), queryName) {
    return InterfaceReducer.getError(state, `${this.getInterfaceUrl()}.history`, queryName);
  }
  isLoading(state = GlobalState.get(), queryName) {
    return InterfaceReducer.isLoading(state, `${this.getInterfaceUrl()}.history`, queryName);
  }
  getStatus(state = GlobalState.get(), queryName) {
    return InterfaceReducer.getStatus(state, `${this.getInterfaceUrl()}.history`, queryName);
  }
  isDone(state = GlobalState.get(), queryName) {
    return InterfaceReducer.isDone(state, `${this.getInterfaceUrl()}.history`, queryName);
  }
}